// import { useLocalObservable } from 'mobx-react'

import { toQueryString } from '../utils/url'
import { getCurrentPage } from './helper'
import { NextRouter } from 'next/router'

// export interface PaginationAble {
// 	readonly pagination: PaginationStore
// }
//

export interface PageResult {
	offset: number
	limit: number
	total: number
	pageSize: number
	page: number
	current: number
}

export interface PageProps {
	offset?: number
	limit?: number
	total?: number
	pageSize?: number
	page?: number
}

export const Page = (props: PageProps) => ({
	_total: props.total,
	_limit: props.limit,
	_offset: props.offset,
	_pageSize: props.pageSize,

	get total(): number {
		return this._total || 0
	},
	get limit(): number {
		return this._limit || 10
	},
	get offset(): number {
		return this._offset || 0
	},
	get pageSize(): number {
		return this._pageSize || this._limit || 10
	},

	setCurrent(offset: number, limit: number, total?: number) {
		this._offset = offset
		this._limit = limit
		if (total) {
			this._total = total
		}
	},

	get current(): PageResult {
		const page = getCurrentPage(this.offset, this.limit)
		return {
			offset: this.offset,
			limit: this.limit,
			total: this.total,
			page,
			current: page,
			pageSize: this.pageSize,
		}
	},
	next(page: number): PageResult {
		const newOffset = this.limit * (page - 1)
		const newPage = getCurrentPage(newOffset, this.limit)
		return {
			offset: newOffset,
			limit: this.limit,
			total: this.total,
			page: newPage,
			current: newPage,
			pageSize: this.pageSize,
		}
	},
})

export type PageType = ReturnType<typeof Page>

export const updatePageChangedWithRouterEvent = function <T extends Record<string, any>>(
	params: T,
	router: NextRouter,
	isReplace: boolean = false,
) {
	const urlParams = new URLSearchParams(params)

	let newQuery = {}
	const urlEntries = Object.fromEntries(urlParams.entries())
	if (Object.keys(urlEntries).length > 0) {
		newQuery = {
			...newQuery,
			...urlEntries,
		}
	} else {
		const defaultParams = Object.keys(router.query).filter(
			(key) => key !== 'offset' && key !== 'limit' && key !== 'slug',
		)
		newQuery = {
			...defaultParams,
		}
	}

	if (isReplace) {
		return router.replace(
			{
				pathname: router.pathname,
				query: { ...router.query, ...newQuery },
			},
			undefined,
			{ shallow: true, scroll: true },
		)
	}
	router.push(
		{
			// pathname: `${router.pathname}?${urlParams}`,
			// pathname: `/category/[slug]?${urlParams}`,
			pathname: router.pathname,
			query: { ...router.query, ...newQuery },
		},
		undefined,
		// {
		// 	pathname: `/category/[slug]?${urlParams}`,
		// 	query: {
		// 		...router.query,
		// 	},
		{ shallow: true, scroll: true },
	)

	// router.push(`${router.pathname}?${urlParams}`, { query: router.query }, { shallow: true })
	// router.push(`${router.pathname}?${urlParams}`, undefined, { shallow: true })
	// return
	// window.history.replaceState(
	// 	window.history.state,
	// 	'',
	// 	window.location.pathname + '?' + urlParams.toString(),
	// )
}

export const deleteParamWithRouterEvent = function (key: string, router: NextRouter) {
	const newQuery = router.query
	delete newQuery[key]
	router.push(`${router.pathname}?${toQueryString(newQuery)}`, undefined, { shallow: true })
}
